import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../TransactionsTypes';
import { ParticipantBrokerDetail } from 'st-common/Transactions/CommonSharedExports';
import { NotificationDuration } from 'st-app/Models/Enums/NotificationDuration';

import UpdateParticipantBrokerDetailCommand from 'st-common/Transactions/Models/UpdateParticipantBrokerDetailCommand';
import Home from 'st-app/Views/Home';

@NeoModel
export default class BrokerDetailsVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private tradeApiClient = AppService.get(Types.Transactions.ApiClients.TradeApiClient),
        public portfolioService = AppService.get(Types.Transactions.Services.PortfolioService),
        private navigation = AppService.get(Types.Neo.Routing.NavigationHelper)) {

        super(taskRunner);
    }

    public brokerDetails: UpdateParticipantBrokerDetailCommand | null = null;
    public showBrokerDetailsClearModal: boolean = false;

    public async initialise() {
        const portfolioData = await this.portfolioService.ensureLoaded(this.taskRunner);

        // If the participant broker details page is hidden, navigate to the home page.
        if (!portfolioData.settings.showParticipantBrokerDetailsPage) {
            this.navigation.navigateToView(Home);
            return;
        }

        const participantBrokerDetail = await this.taskRunner.waitFor(this.tradeApiClient.getParticipantBrokerDetails());

        const command = new UpdateParticipantBrokerDetailCommand();
        if (participantBrokerDetail.data) {
            command.participantBrokerDetail = ParticipantBrokerDetail.fromJSObject<ParticipantBrokerDetail>(participantBrokerDetail.data);
        } else {
            command.participantBrokerDetail = new ParticipantBrokerDetail();
            command.participantBrokerDetail.requireBrokerContactDetails = portfolioData.settings.requireBrokerContactDetails ?? true;
        }
        command.markOld();

        this.brokerDetails = command;
    }

    public saveBrokerDetails() {
        this.taskRunner.run(async () => {
            const result = await this.tradeApiClient.updateParticipantBrokerDetails(this.brokerDetails!.toJSObject());
            this.brokerDetails!.participantBrokerDetail.update(result.data);

            this.notifications.addSuccess("Broker details", "Broker details updated successfully.", NotificationDuration.Standard);
        });
    }

    public clearParticipantBrokerDetails(participantBrokerDetailId: number) {
        this.taskRunner.run(async () => {
            await this.tradeApiClient.deactivateParticipantBrokerDetails(participantBrokerDetailId);
            var restrictedBrokerAccountNumber = this.brokerDetails!.participantBrokerDetail.restrictedBrokerAccountNumber;
            this.brokerDetails!.participantBrokerDetail = new ParticipantBrokerDetail();
            this.brokerDetails!.participantBrokerDetail.requireBrokerContactDetails = this.portfolioService.appData?.settings.requireBrokerContactDetails ?? true;
            this.showBrokerDetailsClearModal = false;
            
            // preserve the restricted broker account number since this does not belong to the participant broker details.
            this.brokerDetails!.participantBrokerDetail.restrictedBrokerAccountNumber = restrictedBrokerAccountNumber;
            this.notifications.addSuccess("Broker details", "Broker details have been removed successfully", NotificationDuration.Standard);
        })

    }
}
